import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
    CustomTooltip,
    setErrorMessage,
} from '../shared/helpers/functionalities';
import { INTEGRACIONES_API } from '../shared/services/piezas';
import { useDispatch } from 'react-redux';
import { integracionesKeys } from './integracionesKeys';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ArrowDropDown, Refresh } from '@mui/icons-material';
import './integraciones.scss';
import IntegracionesTable from './IntegracionesTable';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { IconButton } from '@mui/material';

const Integraciones = () => {
    const [expanded, setExpanded] = useState({
        atenaStatus: false,
        azStatus: false,
        importsStatus: false,
        mbStatus: false,
        seintoStatus: false,
        conmutaStatus: false,
    });
    const [status, setStatus] = useState({
        atenaStatus: [],
        azStatus: [],
        importsStatus: [],
        mbStatus: [],
        seintoStatus: [],
        conmutaStatus: [],
        total: 0,
        totalAZ: 0,
        totalAtena: 0,
        totalIntegrations: 0,
        totalMB: 0,
        totalSeinto: 0,
        totalConmuta: 0,
        saved_cache_at: '',
    });
    const [filterOptions, setFilterOptions] = useState([]);
    const [selected, setSelected] = useState(null);
    const dispatch = useDispatch();

    const handleSelected = useCallback((e, newValue) => {
        setSelected(newValue);
        if (newValue) {
            setExpanded((prev) => ({
                ...prev,
                [newValue.statusKey]: true,
            }));

            setTimeout(() => {
                const rowElement = document.getElementById(
                    `row-${newValue.label}`
                );
                if (rowElement) {
                    rowElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            }, 800);
        }
    }, []);

    const buildFilterOptions = (data) => {
        return Object.keys(data)
            .filter((key) => key.endsWith('Status'))
            .flatMap((key) =>
                data[key].map((item) => ({
                    label: item.name_crm,
                    statusKey: key,
                }))
            );
    };

    const getStatusRequest = async (refresh = false) => {
        try {
            dispatch({ type: 'loading/set', payload: true });
            const res = await INTEGRACIONES_API.getStatus(refresh);
            if (res?.success) {
                const stock = res.data.stock;
                const saved_cache_at = res.data.saved_cache_at;
                setStatus({ ...stock, saved_cache_at });
                setFilterOptions(buildFilterOptions(stock));
            }
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

    useEffect(() => {
        getStatusRequest();
    }, []);

    return (
        <div className="content pt-3 mb-3 integraciones-view">
            <div className="integraciones-view__header">
                <h2>
                    TOTAL PIEZAS:{' '}
                    {new Intl.NumberFormat('es-ES').format(status.total)} piezas
                </h2>
                <CustomTooltip
                    title={'Última actualización: ' + status?.saved_cache_at}
                    onClick={() => getStatusRequest(true)}
                >
                    <IconButton sx={{ color: '#215732' }}>
                        <Refresh />
                    </IconButton>
                </CustomTooltip>
            </div>
            <div className="pb-4">
                <Autocomplete
                    disablePortal
                    options={filterOptions}
                    getOptionLabel={(option) => (option.label).toUpperCase()}
                    sx={{ width: '100%', maxWidth: 400 }}
                    value={selected}
                    onChange={handleSelected}
                    renderInput={(params) => (
                        <TextField {...params} label="Buscar desguace" />
                    )}
                />
            </div>
            {integracionesKeys.map((integracion) => (
                <Accordion
                    key={integracion.tableName}
                    expanded={expanded[integracion.statusKey]}
                    onChange={() =>
                        setExpanded({
                            ...expanded,
                            [integracion.statusKey]:
                                !expanded[integracion.statusKey],
                        })
                    }
                >
                    <AccordionSummary
                        expandIcon={<ArrowDropDown />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <div className="integraciones-view__accordion-summary">
                            <h1>{integracion.tableName}</h1>
                            <div>
                                <p>
                                    Piezas:{' '}
                                    <b>
                                        {new Intl.NumberFormat('es-ES').format(
                                            status[integracion.partsKey]
                                        )}
                                    </b>
                                </p>
                                <p>
                                    Desguaces:{' '}
                                    <b>
                                        {status[integracion.statusKey]?.length}
                                    </b>
                                </p>
                            </div>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="integraciones-view__accordion-details tecdoc__table-container--table">
                            <IntegracionesTable
                                statusInfo={status[integracion.statusKey]}
                                columnNames={integracion.columnNames}
                                selected={selected}
                            />
                        </div>
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    );
};

export default Integraciones;
